module.exports = __webpack_public_path__ + "static/media/chains.f1f5bf7c.mp3";